/* eslint-disable array-callback-return */
import React, { useState, useRef, useContext, useEffect } from "react"
import { Fieldset } from "primereact/fieldset"
import PropTypes from "prop-types"
import { Toast } from "primereact/toast"
import { Toolbar } from "primereact/toolbar"
import SubstanceUseRow from "./SubstanceUseRow"
import CustomToolBar from "../../../ToolBar/customToolbar"
import { MultiSelect } from "primereact/multiselect"
import { ListBox } from "primereact/listbox"
import {
  adjustmentDisorders,
  adultPersonalityDisorders,
  anxietyDisorders,
  behavioralSyndroms,
  confirmation,
  confirmationRefused,
  lastTimeTreatment,
  moodDisorders,
  nonMoodPhyscoDisorders,
  obsessiveCompulsiveDisorders,
  overdosingIntervention,
  treatmentTimes,
} from "../../../types/dropDownTypes"
import { errorMessages } from "../../../types/messages"
import {
  existsErrors,
  getAdditionalQuestions,
  showMessage,
  showQuestion,
  updateState,
  validateQuestions,
  formatMixedQuestions,
  filterAdditionalQuestions,
  checkDisplayConditional,
  checkConditionalRender,
  nextForm,
  prevForm,
} from "../../../utils/utils"
import { GpraContext } from "../../../../../context/gpraContext"
import { endpoints } from "../../../../../config/gpraApiEndpoints"
import SubstanceUseMultiSelectRow from "./SubstanceUseMultiSelectRow"
import FormLabel from "../../../Common/FormLabel"
import FormError from "../../../Common/FormError"
import { Checkbox } from "primereact/checkbox"
import { Dropdown } from "primereact/dropdown"
import gpraStyles from "../../../../../styles/Participant-GPRA.module.css"
import { InputText } from "primereact/inputtext"
import {
  INTERVIEW_SECTIONS,
  INTERVIEW_TYPES,
} from "../../../types/interviewTypes"
import AdditionalQuestionContainer from "../../Additional/AdditionalQuestionContainer"
import { UserContext } from "../../../../../context/userContext"

const SubstanceUse3 = (props) => {
  const { showToolBar, disabled } = props
  const {
    handleSubmitPut,
    interview,
    interviewType,
    handleLoadPrev,
    handleLoadNext,
    handleSectionsCompleted,
    sectionsCompleted,
    questions,
    updateInterviewValues,
    additionalQuestions,
    sections,
    activeIndex,
    administrativeInterview,
    editMode,
  } = useContext(GpraContext)

  const userCtx = useContext(UserContext)

  const [substanceUse3, setSubstanceUse3] = useState(
    interview[INTERVIEW_SECTIONS.SUBSTANCE_USE_3]
  )

  const [mixedQuestions, setMixedQuestions] = useState([])
  const [validationErrors, setValidationErrors] = useState({})
  const toast = useRef(null)

  useEffect(() => {
    if (mixedQuestions.length === 0) {
      let filteredQuestions = []
      let filteredAdditional = []
      if (questions) {
        filteredQuestions = questions.filter(
          (q) => q.section === INTERVIEW_SECTIONS.SUBSTANCE_USE_3
        )
      }
      if (additionalQuestions) {
        filteredAdditional = filterAdditionalQuestions(
          additionalQuestions,
          INTERVIEW_SECTIONS.SUBSTANCE_USE_3
        )
      }
      setMixedQuestions(
        formatMixedQuestions(filteredQuestions, filteredAdditional)
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questions, additionalQuestions])

  const saveData = (setNextForm, previousForm, setNavigationItem) => {
    updateInterviewValues(INTERVIEW_SECTIONS.SUBSTANCE_USE_3, substanceUse3)
    if (previousForm) {
      handleLoadPrev(true)
      setNextForm(prevForm(sections, activeIndex, administrativeInterview))
      setNavigationItem()
    } else {
      if (validForm()) {
        handleLoadNext(true)
        handleSubmitPut(endpoints.SAVE_SUBSTANCE_USE_DATA, {
          GpraBForm: {
            ...substanceUse3,
            gpra_b_6: substanceUse3?.gpra_b_6,
            gpra_b_7a: substanceUse3?.gpra_b_7?.find(
              (i) => i === overdosingIntervention[0].value
            ),
            gpra_b_7b: substanceUse3?.gpra_b_7?.find(
              (i) => i === overdosingIntervention[1].value
            ),
            gpra_b_7c: substanceUse3?.gpra_b_7?.find(
              (i) => i === overdosingIntervention[2].value
            ),
            gpra_b_7d: substanceUse3?.gpra_b_7?.find(
              (i) => i === overdosingIntervention[3].value
            ),
            gpra_b_7e: substanceUse3?.gpra_b_7?.find(
              (i) => i === overdosingIntervention[4].value
            ),
            gpra_b_7f: substanceUse3?.gpra_b_7?.find(
              (i) => i === overdosingIntervention[6].value
            ),
            gpra_b_7g: substanceUse3?.gpra_b_7?.find(
              (i) => i === overdosingIntervention[5].value
            ),
            gpra_b_7g_a: substanceUse3?.gpra_b_7g_a,
            gpra_b_8: substanceUse3?.gpra_b_8,
            gpra_b_9: substanceUse3?.gpra_b_9,
            gpra_b_10: substanceUse3?.gpra_b_10,
            gpra_b_10a_a1: substanceUse3?.gpra_b_10a_a?.find(
              (i) => i === nonMoodPhyscoDisorders[0].value
            ),
            gpra_b_10a_a2: substanceUse3?.gpra_b_10a_a?.find(
              (i) => i === nonMoodPhyscoDisorders[1].value
            ),
            gpra_b_10a_a3: substanceUse3?.gpra_b_10a_a?.find(
              (i) => i === nonMoodPhyscoDisorders[2].value
            ),
            gpra_b_10a_a4: substanceUse3?.gpra_b_10a_a?.find(
              (i) => i === nonMoodPhyscoDisorders[3].value
            ),
            gpra_b_10a_a5: substanceUse3?.gpra_b_10a_a?.find(
              (i) => i === nonMoodPhyscoDisorders[4].value
            ),
            gpra_b_10a_a6: substanceUse3?.gpra_b_10a_a?.find(
              (i) => i === nonMoodPhyscoDisorders[5].value
            ),
            gpra_b_10a_a7: substanceUse3?.gpra_b_10a_a?.find(
              (i) => i === nonMoodPhyscoDisorders[6].value
            ),
            gpra_b_10a_b1: substanceUse3?.gpra_b_10a_b?.find(
              (i) => i === moodDisorders[0].value
            ),
            gpra_b_10a_b2: substanceUse3?.gpra_b_10a_b?.find(
              (i) => i === moodDisorders[1].value
            ),
            gpra_b_10a_b3: substanceUse3?.gpra_b_10a_b?.find(
              (i) => i === moodDisorders[2].value
            ),
            gpra_b_10a_b4: substanceUse3?.gpra_b_10a_b?.find(
              (i) => i === moodDisorders[3].value
            ),
            gpra_b_10a_b5: substanceUse3?.gpra_b_10a_b?.find(
              (i) => i === moodDisorders[4].value
            ),
            gpra_b_10a_b6: substanceUse3?.gpra_b_10a_b?.find(
              (i) => i === moodDisorders[5].value
            ),
            gpra_b_10a_c1: substanceUse3?.gpra_b_10a_c?.find(
              (i) => i === anxietyDisorders[0].value
            ),
            gpra_b_10a_c2: substanceUse3?.gpra_b_10a_c?.find(
              (i) => i === anxietyDisorders[1].value
            ),
            gpra_B_10a_c3: substanceUse3?.gpra_b_10a_c?.find(
              (i) => i === anxietyDisorders[2].value
            ),
            gpra_b_10a_c4: substanceUse3?.gpra_b_10a_c?.find(
              (i) => i === anxietyDisorders[3].value
            ),
            gpra_b_10a_c5: substanceUse3?.gpra_b_10a_c?.find(
              (i) => i === anxietyDisorders[4].value
            ),
            gpra_b_10a_c6: substanceUse3?.gpra_b_10a_c?.find(
              (i) => i === anxietyDisorders[5].value
            ),
            gpra_b_10a_c7: substanceUse3?.gpra_b_10a_c?.find(
              (i) => i === anxietyDisorders[6].value
            ),
            gpra_b_10a_c8: substanceUse3?.gpra_b_10a_c?.find(
              (i) => i === anxietyDisorders[7].value
            ),
            gpra_b_10a_d1: substanceUse3?.gpra_b_10a_d?.find(
              (i) => i === obsessiveCompulsiveDisorders[0].value
            ),
            gpra_b_10a_d2: substanceUse3?.gpra_b_10a_d?.find(
              (i) => i === obsessiveCompulsiveDisorders[1].value
            ),
            gpra_b_10a_d3: substanceUse3?.gpra_b_10a_d?.find(
              (i) => i === obsessiveCompulsiveDisorders[2].value
            ),
            gpra_b_10a_d4: substanceUse3?.gpra_b_10a_d?.find(
              (i) => i === obsessiveCompulsiveDisorders[3].value
            ),
            gpra_b_10a_e1: substanceUse3?.gpra_b_10a_e?.find(
              (i) => i === adjustmentDisorders[0].value
            ),
            gpra_b_10a_e2: substanceUse3?.gpra_b_10a_e?.find(
              (i) => i === adjustmentDisorders[1].value
            ),
            gpra_b_10a_e3: substanceUse3?.gpra_b_10a_e?.find(
              (i) => i === adjustmentDisorders[2].value
            ),
            gpra_b_10a_e4: substanceUse3?.gpra_b_10a_e?.find(
              (i) => i === adjustmentDisorders[3].value
            ),
            gpra_b_10a_e5: substanceUse3?.gpra_b_10a_e?.find(
              (i) => i === adjustmentDisorders[4].value
            ),
            gpra_b_10a_e6: substanceUse3?.gpra_b_10a_e?.find(
              (i) => i === adjustmentDisorders[5].value
            ),
            gpra_b_10a_e7: substanceUse3?.gpra_b_10a_e?.find(
              (i) => i === adjustmentDisorders[6].value
            ),
            gpra_b_10a_f1: substanceUse3?.gpra_b_10a_f?.find(
              (i) => i === behavioralSyndroms[0].value
            ),
            gpra_b_10a_f2: substanceUse3?.gpra_b_10a_f?.find(
              (i) => i === behavioralSyndroms[1].value
            ),
            gpra_b_10a_g1: substanceUse3?.gpra_b_10a_g?.find(
              (i) => i === adultPersonalityDisorders[0].value
            ),
            gpra_b_10a_g2: substanceUse3?.gpra_b_10a_g?.find(
              (i) => i === adultPersonalityDisorders[1].value
            ),
            gpra_b_10a_g3: substanceUse3?.gpra_b_10a_g?.find(
              (i) => i === adultPersonalityDisorders[2].value
            ),
            gpra_b_10a_g4: substanceUse3?.gpra_b_10a_g?.find(
              (i) => i === adultPersonalityDisorders[3].value
            ),
            gpra_b_10a_g5: substanceUse3?.gpra_b_10a_g?.find(
              (i) => i === adultPersonalityDisorders[4].value
            ),
            gpra_b_10a_g6: substanceUse3?.gpra_b_10a_g?.find(
              (i) => i === adultPersonalityDisorders[5].value
            ),
            gpra_b_10a_g7: substanceUse3?.gpra_b_10a_g?.find(
              (i) => i === adultPersonalityDisorders[6].value
            ),
            gpra_b_10a_g8: substanceUse3?.gpra_b_10a_g?.find(
              (i) => i === adultPersonalityDisorders[7].value
            ),
            gpra_b_10a_g9: substanceUse3?.gpra_b_10a_g?.find(
              (i) => i === adultPersonalityDisorders[8].value
            ),
            gpra_b_10a_g10: substanceUse3?.gpra_b_10a_g?.find(
              (i) => i === adultPersonalityDisorders[9].value
            ),
            gpra_b_10a_g11: substanceUse3?.gpra_b_10a_g?.find(
              (i) => i === adultPersonalityDisorders[10].value
            ),
            gpra_b_10a_g12: substanceUse3?.gpra_b_10a_g?.find(
              (i) => i === adultPersonalityDisorders[11].value
            ),
            gpra_b_10ab: substanceUse3?.gpra_b_10ab,
            gpra_b_11: substanceUse3?.gpra_b_11,
            gpra_b_11a: substanceUse3?.gpra_b_11a,
            gpra_b_11b: substanceUse3?.gpra_b_11b,
          },
          GpraInterviewId:
            interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id,
          GpraBId: substanceUse3?.gpra_b_id,
          Additional: getAdditionalQuestions(substanceUse3),
          EditMode: editMode,
          EditedBy: userCtx.session?.user?.staff_id,
        })
          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              handleLoadNext(false)
              setNextForm(
                nextForm(
                  sections,
                  activeIndex,
                  interviewType !== INTERVIEW_TYPES.INTAKE
                    ? administrativeInterview
                    : true
                )
              )
              setNavigationItem()
              handleSectionsCompleted({
                ...sectionsCompleted,
                ...{ substanceUse3: true },
              })
            }
          })
          .catch(() => {
            handleLoadNext(false)
            showMessage(false, errorMessages.genericError, toast)
          })
      } else {
        showMessage(false, errorMessages.toastErrorDetail, toast)
      }
    }
  }

  const removeError = (key) => {
    validationErrors[key] = null
    setValidationErrors(validationErrors)
  }

  const validForm = () => {
    const errors = {}
    if (
      substanceUse3?.gpra_b_6 === undefined &&
      showQuestion(questions, "gpra_b_6")
    ) {
      errors.gpra_b_6 = errorMessages.requiredMessage
    } else if (substanceUse3?.gpra_b_6 && showQuestion(questions, "gpra_b_6")) {
      if (
        substanceUse3?.gpra_b_7.length === 0 &&
        showQuestion(questions, "gpra_b_7")
      ) {
        errors.gpra_b_7 = errorMessages.requiredMessage
      } else if (
        substanceUse3?.gpra_b_7 &&
        substanceUse3?.gpra_b_7[0] === "Other" &&
        !substanceUse3?.gpra_b_7g_a &&
        showQuestion(questions, "gpra_b_7")
      ) {
        errors.gpra_b_7g_a = errorMessages.requiredMessage
      }
    }
    if (!substanceUse3?.gpra_b_8 && showQuestion(questions, "gpra_b_8")) {
      errors.gpra_b_8 = errorMessages.requiredMessage
    } else if (
      substanceUse3?.gpra_b_8 !== "Refused" &&
      substanceUse3?.gpra_b_8 !== "Never" &&
      showQuestion(questions, "gpra_b_8")
    ) {
      if (!substanceUse3?.gpra_b_9 && showQuestion(questions, "gpra_b_9")) {
        errors.gpra_b_9 = errorMessages.requiredMessage
      }
    }
    if (!substanceUse3?.gpra_b_10 && showQuestion(questions, "gpra_b_10")) {
      errors.gpra_b_10 = errorMessages.requiredMessage
    } else if (
      substanceUse3?.gpra_b_10 === "Yes" &&
      showQuestion(questions, "gpra_b_10")
    ) {
      if (
        substanceUse3?.gpra_b_10a_a.length === 0 &&
        substanceUse3?.gpra_b_10a_b.length === 0 &&
        substanceUse3?.gpra_b_10a_c.length === 0 &&
        substanceUse3?.gpra_b_10a_d.length === 0 &&
        substanceUse3?.gpra_b_10a_e.length === 0 &&
        substanceUse3?.gpra_b_10a_f.length === 0 &&
        substanceUse3?.gpra_b_10a_g.length === 0 &&
        !substanceUse3?.gpra_b_10ab
      ) {
        errors.gpra_b_10ab = errorMessages.mentalHealthIlness
      }
    }

    setValidationErrors(
      validateQuestions(
        substanceUse3,
        INTERVIEW_SECTIONS.SUBSTANCE_USE_3,
        additionalQuestions,
        errors,
        questions
      )
    )
    return existsErrors(errors)
  }

  const renderDefaultMain = (question) => {
    if (question.field === "gpra_b_6") {
      return (
        <>
          <div className={gpraStyles.formRow}>
            <FormLabel
              label={`${question.number}. In the past 30 days, did you experience an overdose or take too much of a substance that resulted in needing supervision or medical attention?`}
              required
            />
          </div>
          <div className={gpraStyles.formRow}>
            <SubstanceUseRow
              entity={substanceUse3}
              setEntity={setSubstanceUse3}
              summaryDisabled={disabled}
              confirmation={substanceUse3?.gpra_b_6}
              setConfirmation={"gpra_b_6"}
              confirmationOptions={confirmation}
              showRoute={false}
              showConfirmation
              showDays={false}
              removeError={removeError}
              numberError={validationErrors.gpra_b_6}
              numberErrorType="gpra_b_6"
              extraValues={[{ key: "gpra_b_7", value: [] }]}
              defaultZero={question.defaultZero}
            />
          </div>
        </>
      )
    }
    if (question.field === "gpra_b_7" && substanceUse3?.gpra_b_6) {
      return (
        <>
          <div className={gpraStyles.formRow}>
            <FormLabel
              label={`${question.number}. In the past 30 days, after taking too much of a substance or overdosing, what intervention did you receive? You may indicate more than one.`}
              required
            />
            {disabled ? (
              <ListBox
                disabled
                options={substanceUse3?.gpra_b_7}
                className={gpraStyles.input4}
              />
            ) : (
              <MultiSelect
                value={substanceUse3?.gpra_b_7}
                maxSelectedLabels={3}
                options={overdosingIntervention}
                onChange={(e) => {
                  if (e.value?.find((i) => i === "Other")) {
                    updateState(
                      "gpra_b_7",
                      ["Other"],
                      null,
                      null,
                      substanceUse3,
                      setSubstanceUse3,
                      null
                    )
                  } else if (e.value?.find((i) => i === "Refused")) {
                    updateState(
                      "gpra_b_7",
                      ["Refused"],
                      null,
                      null,
                      substanceUse3,
                      setSubstanceUse3,
                      null
                    )
                  } else {
                    updateState(
                      "gpra_b_7",
                      e.value,
                      null,
                      null,
                      substanceUse3,
                      setSubstanceUse3,
                      null
                    )
                  }
                  removeError("gpra_b_7")
                }}
                optionLabel="label"
                optionValue="value"
                showSelectAll={false}
                showClear={substanceUse3?.gpra_b_7}
                disabled={disabled}
                className={
                  validationErrors.gpra_b_7
                    ? gpraStyles.input4Error
                    : gpraStyles.input4
                }
              />
            )}

            <FormError error={validationErrors.gpra_b_7} />
          </div>
          {substanceUse3?.gpra_b_7 &&
            substanceUse3?.gpra_b_7[0] === "Other" && (
              <div className={gpraStyles.formRow}>
                <InputText
                  className={
                    validationErrors.gpra_b_7g_a
                      ? gpraStyles.inputText4AuxError
                      : gpraStyles.inputText4Aux
                  }
                  disabled={disabled}
                  value={substanceUse3?.gpra_b_7g_a}
                  onChange={(e) => {
                    updateState(
                      "gpra_b_7g_a",
                      e.target.value,
                      null,
                      null,
                      substanceUse3,
                      setSubstanceUse3,
                      null
                    )
                    removeError("gpra_b_7g_a")
                  }}
                />
                <FormError error={validationErrors.gpra_b_7g_a} />
              </div>
            )}
        </>
      )
    }
    if (question.field === "gpra_b_8") {
      return (
        <>
          <div className={gpraStyles.formRow}>
            <FormLabel
              label={`${question.number}. Not including this current episode, how many times in your life have you been treated at an inpatient or outpatient facility for a substance use disorder?`}
              required
            />
          </div>
          <div className={gpraStyles.formRow}>
            <SubstanceUseRow
              entity={substanceUse3}
              setEntity={setSubstanceUse3}
              summaryDisabled={disabled}
              confirmation={substanceUse3?.gpra_b_8}
              setConfirmation={"gpra_b_8"}
              confirmationOptions={treatmentTimes}
              showRoute={false}
              showConfirmation
              showDays={false}
              removeError={removeError}
              confirmationSize="4"
              numberErrorType={"gpra_b_8"}
              numberError={validationErrors.gpra_b_8}
              extraValues={[{ key: "gpra_b_9", value: "" }]}
              defaultZero={question.defaultZero}
            />
          </div>
        </>
      )
    }
    if (
      question.field === "gpra_b_9" &&
      substanceUse3?.gpra_b_8 !== "Refused" &&
      substanceUse3?.gpra_b_8 !== "Never" &&
      substanceUse3?.gpra_b_8
    ) {
      return (
        <>
          <div className={gpraStyles.formRow}>
            <FormLabel
              label={`${question.number}. Approximately when was the last time you received inpatient or outpatient treatment for a substance use disorder?`}
              required
            />
          </div>
          <div className={gpraStyles.formRow}>
            <SubstanceUseRow
              entity={substanceUse3}
              setEntity={setSubstanceUse3}
              summaryDisabled={disabled}
              confirmation={substanceUse3?.gpra_b_9}
              setConfirmation={"gpra_b_9"}
              confirmationOptions={lastTimeTreatment}
              showRoute={false}
              showConfirmation
              showDays={false}
              removeError={removeError}
              numberError={validationErrors.gpra_b_9}
              numberErrorType="gpra_b_9"
              confirmationSize="5"
              defaultZero={question.defaultZero}
            />
          </div>
        </>
      )
    }
    if (question.field === "gpra_b_10") {
      return (
        <>
          <div className={gpraStyles.formRow}>
            <FormLabel
              label={`${question.number}. Have you ever been diagnosed with a mental health illness by a health care professional?`}
              required
            />
          </div>
          <div className={gpraStyles.formRow}>
            <SubstanceUseRow
              entity={substanceUse3}
              setEntity={setSubstanceUse3}
              summaryDisabled={disabled}
              confirmation={substanceUse3?.gpra_b_10}
              setConfirmation={"gpra_b_10"}
              confirmationOptions={confirmationRefused}
              showRoute={false}
              showConfirmation
              showDays={false}
              removeError={removeError}
              numberError={validationErrors.gpra_b_10}
              numberErrorType="gpra_b_10"
              confirmationSize={"2"}
              removeErrors={[
                "gpra_b_10a_a",
                "gpra_b_10a_b",
                "gpra_b_10a_c",
                "gpra_b_10a_d",
                "gpra_b_10a_e",
                "gpra_b_10a_f",
                "gpra_b_10a_g",
                "gpra_b_10ab",
              ]}
              extraValues={[
                { key: "gpra_b_10ab", value: false },
                { key: "gpra_b_10a", value: [] },
                { key: "gpra_b_10b", value: [] },
                { key: "gpra_b_10c", value: [] },
                { key: "gpra_b_10d", value: [] },
                { key: "gpra_b_10e", value: [] },
                { key: "gpra_b_10f", value: [] },
                { key: "gpra_b_10g", value: [] },
              ]}
              defaultZero={question.defaultZero}
            />
          </div>
          {substanceUse3?.gpra_b_10 === "Yes" && (
            <>
              <div className={gpraStyles.formRow}>
                <FormLabel
                  label={
                    "a. [IF YES] Please ask the client to self-report their mental health illnesses as listed in the table below. The client should be encouraged to report their own mental health illnesses but if preferred, the list can be read to the client."
                  }
                  required
                />
              </div>
              <div className={gpraStyles.formRow}>
                <SubstanceUseMultiSelectRow
                  entity={substanceUse3}
                  setEntity={setSubstanceUse3}
                  legend="Schizophrenia, schizotypal, delusional, and other non-mood psychotic disorders"
                  value={substanceUse3?.gpra_b_10a_a}
                  setValue={"gpra_b_10a_a"}
                  disabled={
                    disabled ||
                    substanceUse3?.gpra_b_10ab ||
                    substanceUse3?.gpra_b_10 !== "Yes"
                  }
                  removeError={removeError}
                  error={validationErrors.gpra_b_10a_a}
                  errorType="gpra_b_10a_a"
                  options={nonMoodPhyscoDisorders}
                  removeErrors={["gpra_b_10ab"]}
                  summary={disabled}
                />
                <SubstanceUseMultiSelectRow
                  entity={substanceUse3}
                  setEntity={setSubstanceUse3}
                  legend="Mood [affective] disorders"
                  value={substanceUse3?.gpra_b_10a_b}
                  setValue={"gpra_b_10a_b"}
                  disabled={
                    disabled ||
                    substanceUse3?.gpra_b_10ab ||
                    substanceUse3?.gpra_b_10 !== "Yes"
                  }
                  removeError={removeError}
                  error={validationErrors.gpra_b_10a_b}
                  errorType="gpra_b_10a_b"
                  options={moodDisorders}
                  removeErrors={["gpra_b_10ab"]}
                  summary={disabled}
                />
                <SubstanceUseMultiSelectRow
                  entity={substanceUse3}
                  setEntity={setSubstanceUse3}
                  legend="Phobic Anxiety and Other Anxiety Disorders"
                  value={substanceUse3?.gpra_b_10a_c}
                  setValue={"gpra_b_10a_c"}
                  disabled={
                    disabled ||
                    substanceUse3?.gpra_b_10ab ||
                    substanceUse3?.gpra_b_10 !== "Yes"
                  }
                  removeError={removeError}
                  error={validationErrors.gpra_b_10a_c}
                  errorType="gpra_b_10a_c"
                  options={anxietyDisorders}
                  removeErrors={["gpra_b_10ab"]}
                  summary={disabled}
                />
                <SubstanceUseMultiSelectRow
                  entity={substanceUse3}
                  setEntity={setSubstanceUse3}
                  legend="Obsessive-compulsive disorders"
                  value={substanceUse3?.gpra_b_10a_d}
                  setValue={"gpra_b_10a_d"}
                  disabled={
                    disabled ||
                    substanceUse3?.gpra_b_10ab ||
                    substanceUse3?.gpra_b_10 !== "Yes"
                  }
                  removeError={removeError}
                  error={validationErrors.gpra_b_10a_d}
                  errorType="gpra_b_10a_d"
                  options={obsessiveCompulsiveDisorders}
                  removeErrors={["gpra_b_10ab"]}
                  summary={disabled}
                />
                <SubstanceUseMultiSelectRow
                  entity={substanceUse3}
                  setEntity={setSubstanceUse3}
                  legend="Reaction to severe stress and adjustment disorders"
                  value={substanceUse3?.gpra_b_10a_e}
                  setValue={"gpra_b_10a_e"}
                  disabled={
                    disabled ||
                    substanceUse3?.gpra_b_10ab ||
                    substanceUse3?.gpra_b_10 !== "Yes"
                  }
                  removeError={removeError}
                  error={validationErrors.gpra_b_10a_e}
                  errorType="gpra_b_10a_e"
                  options={adjustmentDisorders}
                  removeErrors={["gpra_b_10ab"]}
                  summary={disabled}
                />
                <SubstanceUseMultiSelectRow
                  entity={substanceUse3}
                  setEntity={setSubstanceUse3}
                  legend="Behavioral syndromes associated with physiological disturbances and physical factors"
                  value={substanceUse3?.gpra_b_10a_f}
                  setValue={"gpra_b_10a_f"}
                  disabled={
                    disabled ||
                    substanceUse3?.gpra_b_10ab ||
                    substanceUse3?.gpra_b_10 !== "Yes"
                  }
                  removeError={removeError}
                  error={validationErrors.gpra_b_10a_f}
                  errorType="gpra_b_10a_f"
                  options={behavioralSyndroms}
                  removeErrors={["gpra_b_10ab"]}
                  summary={disabled}
                />
                <SubstanceUseMultiSelectRow
                  entity={substanceUse3}
                  setEntity={setSubstanceUse3}
                  legend="Disorders of adult personality and behavior"
                  value={substanceUse3?.gpra_b_10a_g}
                  setValue={"gpra_b_10a_g"}
                  disabled={
                    disabled ||
                    substanceUse3?.gpra_b_10ab ||
                    substanceUse3?.gpra_b_10 !== "Yes"
                  }
                  removeError={removeError}
                  error={validationErrors.gpra_b_10a_g}
                  errorType="gpra_b_10a_g"
                  options={adultPersonalityDisorders}
                  removeErrors={["gpra_b_10ab"]}
                  summary={disabled}
                />
              </div>
              <div className={gpraStyles.formRow}>
                <div className={gpraStyles.checkbox}>
                  <Checkbox
                    id="binary"
                    checked={substanceUse3?.gpra_b_10ab}
                    onChange={(e) => {
                      if (e.target.checked) {
                        updateState(
                          "gpra_b_10ab",
                          e.target.checked,
                          null,
                          null,
                          substanceUse3,
                          setSubstanceUse3,
                          [
                            { key: "gpra_b_10a_a", value: [] },
                            { key: "gpra_b_10a_b", value: [] },
                            { key: "gpra_b_10a_c", value: [] },
                            { key: "gpra_b_10a_d", value: [] },
                            { key: "gpra_b_10a_e", value: [] },
                            { key: "gpra_b_10a_f", value: [] },
                            { key: "gpra_b_10a_g", value: [] },
                          ]
                        )
                      } else {
                        updateState(
                          "gpra_b_10ab",
                          e.target.checked,
                          null,
                          null,
                          substanceUse3,
                          setSubstanceUse3,
                          null
                        )
                      }
                    }}
                    disabled={disabled}
                    className={
                      validationErrors.gpra_b_10ab && gpraStyles.invalid
                    }
                  />
                  <label className={gpraStyles.ml1} htmlFor="binary">
                    {"NONE OF THE ABOVE"}
                  </label>
                </div>
                <div className={gpraStyles.mt1}>
                  <FormError error={validationErrors.gpra_b_10ab} />
                </div>
              </div>
            </>
          )}
        </>
      )
    }
    if (question.interviewType === "Intake" && question.field === "gpra_b_11") {
      return (
        <>
          <div className={gpraStyles.formRow}>
            <FormLabel
              label={`${question.number}. Was the client screened by your program, using an evidence-based tool or set of questions, for co-occurring mental health and/or substance use disorders?`}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <Dropdown
              disabled={disabled || interviewType !== "Intake"}
              className={
                validationErrors.gpra_b_11
                  ? gpraStyles.input3Error
                  : gpraStyles.input3
              }
              value={substanceUse3?.gpra_b_11}
              onChange={(e) => {
                removeError("gpra_b_11")
                removeError("gpra_b_11a")
                removeError("gpra_b_11b")
                if (!e.value) {
                  updateState(
                    "gpra_b_11",
                    e.value,
                    null,
                    null,
                    substanceUse3,
                    setSubstanceUse3,
                    [
                      { key: "gpra_b_11a", value: false },
                      { key: "gpra_b_11a", value: false },
                    ]
                  )
                } else {
                  updateState(
                    "gpra_b_11",
                    e.value,
                    null,
                    null,
                    substanceUse3,
                    setSubstanceUse3,
                    [
                      { key: "gpra_b_11a", value: "" },
                      { key: "gpra_b_11a", value: "" },
                    ]
                  )
                }
              }}
              options={confirmation}
              showClear={substanceUse3?.gpra_b_11}
              optionLabel="label"
              optionValue="value"
            />
            <FormError error={validationErrors.gpra_b_11} errorType={2} />
          </div>
          {substanceUse3?.gpra_b_11 && (
            <>
              <div className={gpraStyles.formRow}>
                <FormLabel
                  label={`${question.number}a. Did the client screen positive for co-occurring mental health and substance use disorders?`}
                />
              </div>
              <div className={gpraStyles.formRow}>
                <Dropdown
                  disabled={disabled || !substanceUse3?.gpra_b_11}
                  className={
                    validationErrors.gpra_b_11a
                      ? gpraStyles.input3Error
                      : gpraStyles.input3
                  }
                  value={substanceUse3?.gpra_b_11a}
                  onChange={(e) => {
                    removeError("gpra_b_11a")
                    if (!e.value) {
                      updateState(
                        "gpra_b_11a",
                        e.value,
                        null,
                        null,
                        substanceUse3,
                        setSubstanceUse3,
                        [{ key: "gpra_b_11b", value: false }]
                      )
                    } else {
                      updateState(
                        "gpra_b_11a",
                        e.value,
                        null,
                        null,
                        substanceUse3,
                        setSubstanceUse3,
                        null
                      )
                    }
                  }}
                  options={confirmation}
                  showClear={substanceUse3?.gpra_b_11a}
                  optionLabel="label"
                  optionValue="value"
                />
                <FormError error={validationErrors.gpra_b_11a} />
              </div>
            </>
          )}
          {substanceUse3?.gpra_b_11a && (
            <>
              <div className={gpraStyles.formRow}>
                <FormLabel
                  label={`${question.number}b. Was the client referred for further assessment for a co-occurring mental health and substance use disorder?`}
                />
              </div>
              <div className={gpraStyles.formRow}>
                <Dropdown
                  disabled={disabled || !substanceUse3?.gpra_b_11a}
                  className={
                    validationErrors.gpra_b_11b
                      ? gpraStyles.input3Error
                      : gpraStyles.input3
                  }
                  value={substanceUse3?.gpra_b_11b}
                  onChange={(e) => {
                    updateState(
                      "gpra_b_11b",
                      e.value,
                      null,
                      null,
                      substanceUse3,
                      setSubstanceUse3,
                      null
                    )
                    removeError("gpra_b_11b")
                  }}
                  options={confirmation}
                  showClear={substanceUse3?.gpra_b_11b}
                  optionLabel="label"
                  optionValue="value"
                />
                <FormError error={validationErrors.gpra_b_11b} />
              </div>
            </>
          )}
        </>
      )
    }
  }
  return (
    <div>
      <Toast ref={toast} />
      {showToolBar && (
        <Toolbar
          className={gpraStyles.mb2}
          right={
            <CustomToolBar
              prevForm={true}
              nextForm={true}
              saveData={saveData}
              toast={toast}
            />
          }
        ></Toolbar>
      )}
      <Fieldset
        legend="B. SUBSTANCE USE AND PLANNED SERVICES"
        style={{ marginBottom: "1rem" }}
      >
        <div className={gpraStyles.grid}>
          {mixedQuestions?.map((question) => {
            if (question.kind === "default") {
              if (question.show) {
                return renderDefaultMain(question)
              }
            } else {
              if (
                checkConditionalRender(
                  question.enabled,
                  question.required,
                  question.kind,
                  question.conditionalSource
                )
              ) {
                return (
                  <AdditionalQuestionContainer
                    entity={substanceUse3}
                    setEntity={setSubstanceUse3}
                    errors={validationErrors}
                    section={INTERVIEW_SECTIONS.SUBSTANCE_USE_3}
                    removeError={removeError}
                    disabled={disabled}
                    question={question.question}
                    number={question.number}
                    kind={question.kind}
                  />
                )
              } else {
                if (checkDisplayConditional(question, substanceUse3)) {
                  return (
                    <AdditionalQuestionContainer
                      entity={substanceUse3}
                      setEntity={setSubstanceUse3}
                      errors={validationErrors}
                      section={INTERVIEW_SECTIONS.SUBSTANCE_USE_3}
                      removeError={removeError}
                      disabled={disabled}
                      question={question.question}
                      number={question.number}
                      kind={question.kind}
                    />
                  )
                }
              }
            }
          })}
        </div>
      </Fieldset>
      {showToolBar && (
        <Toolbar
          className="mt-4"
          right={
            <CustomToolBar
              prevForm={true}
              nextForm={true}
              saveData={saveData}
              toast={toast}
            />
          }
        ></Toolbar>
      )}
    </div>
  )
}

SubstanceUse3.propTypes = {
  showToolBar: PropTypes.bool,
  disabled: PropTypes.bool,
}

SubstanceUse3.defaultProps = {
  showToolBar: true,
  disabled: false,
}

export default SubstanceUse3
